import { Vector3 } from "three";

import Element from "./element";

export default class Box extends Element {
	width: number;
	height: number;
	depth: number;

	constructor({
		id,
		color,
		width,
		height,
		depth
	}: {
		id: string;
		color: string;
		width: number;
		height: number;
		depth: number;
	}) {
		super({ id, color, type: "box" });
		this.width = width;
		this.height = height;
		this.depth = depth;
	}
	getParts() {
		const dimensions: Vector = [this.width, this.height, this.depth];
		return [{ position: new Vector3(0, 0, 0), dimensions }];
	}
	getBoundingBox() {
		return [this.width, this.height, this.depth] as Vector;
	}
	showInfos() {
		return `${this.type}: (${this.width}, ${this.height}, ${this.depth})`;
	}
	cloneUpdate(name: string, value: string | number) {
		return new Box({ ...this, [name]: value });
	}
	cloneWithZoom(zoom: number) {
		return new Box({
			id: this.id,
			color: this.color,
			width: this.width * zoom,
			height: this.height * zoom,
			depth: this.depth * zoom
		});
	}
	toJson() {
		const { id, color, type, width, height, depth } = this;
		return { id, color, type, props: { width, height, depth } };
	}
}
